import React, { Component } from "react";
import Textarea from "react-textarea-autosize";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";

import Swipable from "./Swipable";

export class Link extends Component {
  state = {
    description: this.props.description,
  };

  onUpdate = debounce(
    () =>
      this.props.onUpdate({
        id: this.props.id,
        description: this.state.description,
      }),
    250
  );

  render() {
    const { title, url, favIconUrl, id } = this.props;
    const { isSelected, onClick, onRender, onFocus, onBlur } = this.props;
    const { archive, destroy } = this.props;
    const { description } = this.state;
    const hideButtons = true;

    return (
      <Swipable onLeft={destroy} onRight={archive}>
        <div
          className={
            "list-group-item list-group-item-action flex-column align-items-start" +
            (isSelected ? " active" : "")
          }
          ref={onRender}
          onClick={onClick}
        >
          <div className="d-flex w-100 justify-content-between">
            <a href={url} target="_blank" ref={ref => (this.link = ref)}>
              <h5
                className="mb-1"
                style={{ display: "flex", alignItems: "center" }}
              >
                <img src={favIconUrl} style={{ width: 16, marginRight: 4 }} />
                <span>{title}</span>
              </h5>
            </a>
            {!hideButtons && (
              <button type="button" className="btn btn-outline-danger btn-sm">
                Delete
              </button>
            )}
          </div>

          <a href={url} style={{ opacity: 0.5 }}>
            {url}
          </a>

          <Textarea
            className="form-control"
            style={{ marginTop: 5, marginBottom: 10 }}
            onFocus={onFocus}
            onBlur={onBlur}
            value={description}
            inputRef={ref => (this.textarea = ref)}
            onKeyPress={e => {
              console.log(e.key);
              if (e.key === "Enter" && !e.shiftKey) {
                this.textarea.blur();
                this.link.focus();
                this.onUpdate.flush();
              }
            }}
            onChange={e =>
              this.setState({ description: e.target.value }, this.onUpdate)
            }
          />

          {!hideButtons && (
            <button type="button" className="btn btn-outline-primary btn-block">
              archive
            </button>
          )}
        </div>
      </Swipable>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
Link.propTypes = {};

export default Link;



// WEBPACK FOOTER //
// ./src/Link.js